<template>
  <ListItemAccount
    :key="user.login"
    v-bind="{
      type: user.type,
      avatar: user.avatar,
      name: $filters.displayName(user),
      accountId: user.login,
      approved: user.approved,
      role: roleString,
      vanityId: user.vanityId || user.vanity_id,
    }"
  >
    <template v-if="actions.length" slot="action">
      <ThreeDots v-if="actions.length > 1" :items="actions" />
      <Icon
        v-else
        class="cursor-pointer"
        name="chat"
        @click.prevent="actions[0].action"
      />
    </template>
  </ListItemAccount>
</template>

<script>
import { mapState } from 'vuex';

import { CLAN_ROLES } from '@/constants/accounts';

import ListItemAccount from '@/components/common/ListItemAccount';
import ThreeDots from '@/components/common/ThreeDots';
import Icon from '@/components/atoms/Icon';

export default {
  name: 'MembersListItem',

  components: {
    ListItemAccount,
    ThreeDots,
    Icon,
  },

  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState('current', { clan: 'account' }),
    ...mapState('my', { myAccountId: 'accountId' }),
    roleString() {
      return this.user.role === CLAN_ROLES.MEMBER ? '' : this.user.role;
    },
    actions() {
      if (this.myAccountId === this.user.login) {
        return [];
      }

      const items = [
        {
          label: this.$t('_web_account_chat', 'Chat'),
          action: () => this.$emit('openChat'),
        },
      ];

      if (!this.clan.canManage) {
        return items;
      }

      const myRole = this.clan.role;
      const userRole = this.user.role;

      // owner actions
      if (myRole === CLAN_ROLES.OWNER) {
        items.push({
          label: this.$t('_web_clan-manage_make-owner', 'Make an Owner'),
          action: () => this.$emit('setAsOwner'),
        });
        if (userRole === CLAN_ROLES.DEPUTY) {
          items.push(
            // userRole === CLAN_ROLES.DEPUTY
            //   ?
            {
              label: this.$t('_web_clan-manage_make-member', 'Make a Member'),
              action: () => this.$emit('updateRole', CLAN_ROLES.MEMBER),
            }
            // : {
            //     label: this.$t('_web_clan-manage_make-deputy', 'Make a Deputy'),
            //     action: () => this.$emit('updateRole', CLAN_ROLES.DEPUTY),
            //   }
          );
        }
      }

      // owner and deputy action(s)
      if (
        myRole === CLAN_ROLES.OWNER ||
        (myRole === CLAN_ROLES.DEPUTY && userRole === CLAN_ROLES.MEMBER)
      ) {
        items.push({
          label: this.$t('_web_team-manage_make-member', 'Remove from team'),
          action: () => this.$emit('removeFromClan'),
        });
      }

      return items;
    },
  },
};
</script>
